import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { AlertTriangle, X, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getRoleDisplayName } from '../../../utils/roleUtils';

export const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, userProfile, originalUser, exitImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !userProfile || !originalUser) {
    return null;
  }
  
  const handleExit = () => {
    exitImpersonation();
    navigate('/dashboard');
    window.location.reload(); // Refresh to reset all state
  };
  
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg" style={{ height: '60px' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <AlertTriangle className="w-5 h-5 animate-pulse" />
              <span className="font-semibold">IMPERSONATION MODE</span>
            </div>
            
            <div className="h-6 w-px bg-white/30" />
            
            <div className="flex items-center space-x-2">
              <User className="w-4 h-4" />
              <span className="text-sm">
                Viewing as: <strong>{userProfile.displayName}</strong>
              </span>
              <span className="text-xs bg-white/20 px-2 py-1 rounded">
                {getRoleDisplayName(userProfile.role)}
              </span>
            </div>
          </div>
          
          <button
            onClick={handleExit}
            className="flex items-center space-x-2 bg-white text-orange-600 px-4 py-2 rounded-lg font-medium hover:bg-orange-50 transition-colors"
          >
            <X className="w-4 h-4" />
            <span>Exit Impersonation</span>
          </button>
        </div>
      </div>
    </div>
  );
};